import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * GetExportDetails
 *
 * @TODO Needs description.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const GetExportDetails = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': `/action-paths/${thePayload?.actionPathId}/extracts/latest`,
      },
      method: 'GET',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/RiskRecord/api/requests/queries/GetExportDetails.js -> GetExportDetails()',
      false,
      error
    );

    throw error;
  }
};
